import { createAction } from 'redux-actions';

export const otpCodeSignIn = createAction('USER_REGISTRATION_OTP_CODE_SIGN_IN');

export const passwordSignIn = createAction('USER_REGISTRATION_PASSWORD_SIGN_IN');
export const passwordSignInError = createAction('USER_REGISTRATION_PASSWORD_SIGN_IN_ERROR');
export const camDxSignInError = createAction('USER_REGISTRATION_CAM_DX_SIGN_IN_ERROR');
